"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var numberFormat = function numberFormat(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18n = arguments.length > 2 ? arguments[2] : undefined;
  var language = options.lang ? options.lang : i18n.instance && i18n.instance.language || 'en';

  try {
    var nf = Intl.NumberFormat(language, options);
    return nf.format(value || 0);
  } catch (e) {
    return value;
  }
};

var _default = numberFormat;
exports["default"] = _default;
//# sourceMappingURL=numberFormat.js.map